import { Outlet } from "react-router-dom"

const EmpleadosModule= ()=>{
    return <Outlet />
}

export default EmpleadosModule